export const API_KEY = "5e39165a-9749-4d85-9dff-4bfbbe9892c5";
export const API_URL = "https://api.fastbankapi.com/api/v2/statement/demo/";
export const PUSHER_APP_KEY = "371e07a486352a2ae4fa";
export const PUSHER_CHANEL_NAME = "fastbank-channel";
export const PUSHER_APP_CUSTER = "ap1";
